import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=f2f7b484&scoped=true&lang=html&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"
import style0 from "./menu.vue?vue&type=style&index=0&id=f2f7b484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f7b484",
  null
  
)

component.options.__file = "menu.vue"
export default component.exports